import { ReactNode, useState } from 'react';
import { Icon } from '@iconify/react';
import Input, { InputProps } from './Input';
import clsxm from 'src/utils/clsxm';
import InputGroup from './InputGroup';
import InputGroupAddon from './InputGroupAddon';
import Label from './Label';

type InputSearchProps = {
  searchIcon?: string;
  htmlFor?: string;
  label?: string;
  handleSearchClick?: () => void;
  labelClassName?: string;
  groupClassName?: string;
  addonClassName?: string;
} & InputProps;

const InputSearch = ({
  searchIcon,
  htmlFor,
  label,
  handleSearchClick,
  groupClassName,
  addonClassName,
  labelClassName,
  ...rest
}: InputSearchProps) => {
  const renderIcon = () => {
    return searchIcon ? (
      searchIcon
    ) : (
      <Icon icon="ant-design:search-outlined" width={24} height={24} />
    );
  };

  return (
    <>
      {label && (
        <Label className={labelClassName} htmlFor={htmlFor}>
          {label}
        </Label>
      )}
      <InputGroup className={groupClassName}>
        <Input type="text" {...rest} />
        <InputGroupAddon
          onClick={handleSearchClick}
          className={clsxm('cursor-pointer', addonClassName)}
          addonType="append"
        >
          <span className="input-group-text">{renderIcon()}</span>
        </InputGroupAddon>
      </InputGroup>
    </>
  );
};

export default InputSearch;
